// extracted by mini-css-extract-plugin
export default {"embed":"PowerBIReport_embed__5bc-a"};